module.exports = __webpack_public_path__ + "f080113971226dac11ef1d23ab28a6aa.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/spiky-hair.png
// module id = 2791
// module chunks = 0